import http from "./httpService";

const endPoint = "/api/v1/Categories";


export async function addCategory(request) {
    return await http.post(endPoint, request);
}

export async function getAllCategories() {
    return await http.get(`${endPoint}/All`);
}

export async function getActiveCategories() {
    return await http.get(`${endPoint}`);
}

export function updateCategory(id, request) {
    return http.put(`${endPoint}/${id}`, request);
}

export function updateCategoryImage(id, request) {
    return http.put(`${endPoint}/${id}/Image`, request );
}

export async function getCategoriesProducts(id, onlyActive) {
    return await http.get(`${endPoint}/${id}/Products`, {
        params: {
            id: id,
            onlyActive: onlyActive,
        }
    });
}

export async function addToStorageLocation(category, product, request) {
    return await http.post(`${endPoint}/${category}/Product/${product}/StorageLocations`, request);
}

export async function getProductStorageLocations(category, product) {
    return await http.get(`${endPoint}/${category}/Product/${product}/StorageLocations`, {
        params: {
            categoryId: category,
            productId: product
        }
    });
}

export default { addCategory, getAllCategories, getActiveCategories, updateCategory, 
                 updateCategoryImage, getCategoriesProducts, addToStorageLocation,
                 getProductStorageLocations };


// WEBPACK FOOTER //
// ./src/services/CategoriesService.js